// Check for IntersectionObserver support
if ('IntersectionObserver' in window) {
  document.addEventListener("DOMContentLoaded", function() {

    function handleIntersection(entries) {
      entries.map((entry) => {
        if (entry.isIntersecting) {
          // Item has crossed our observation
          // threshold - load src from data-src
          entry.target.style.backgroundImage = "url('"+entry.target.dataset.bgimage+"')";
          // Job done for this item - no need to watch it!
          observer.unobserve(entry.target);
        }
      });
    }

    const bgimages = document.querySelectorAll('.bgimage');
    const observer = new IntersectionObserver(
      handleIntersection,
      { rootMargin: "100px" }
    );
    bgimages.forEach(header => observer.observe(header));
  });
} else {
  // No interaction support? Load all background images automatically
  const bgimages = document.querySelectorAll('.bgimage');
  bgimages.forEach(header => {
    bgimage.style.backgroundImage = "url('"+header.dataset.bgimage+"')";
  });
}